// A plain Bootstrap spinner — no branded asset to spin (unlike lilac's
// mark-based Spinner), so this leans entirely on `.spinner-border`, which is
// already theme-adaptive.
export function Spinner({ size = 24 }: { size?: number }) {
	return (
		<span
			class="spinner-border text-primary"
			style={{ width: size, height: size, borderWidth: Math.max(2, size / 8) }}
			role="status"
		>
			<span class="visually-hidden">Loading…</span>
		</span>
	)
}
